import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { Grid, IconButton, Tooltip, Chip } from "@mui/material";

import pages from "../../../constants/pages";
import { Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.publicisBlue};
  color: ${colors.publicisBlue};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  border-radius: 10px;
  &:hover {
    border: 1px solid ${colors.publicisBlue};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({ brands, loading }) {
  const navigate = useNavigate();
  var columns = [
    {
      name: "brand_name",
      label: "Brand Name",
    },

    {
      name: "about",
      label: "About Brand",
    },

    {
      name: "is_visible",
      label: "Brand Status",
    },

    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "is_visible") {
      return (
        <Chip
          style={{
            fontSize: "13px",
            backgroundColor: value ? colors.lightSuccess : colors.lightError,
            color: value ? colors.success : colors.error,
          }}
          label={value ? "Active" : "Inactive"}
        />
      );
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Brand">
            <Icon>
              <CgEye
                onClick={() =>
                  navigate(pages.brandDetails.route, {
                    state: {
                      brandID: row.brand_id,
                    },
                  })
                }
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          //   components={[
          //     <ToolBar setPage={setPage} setSearchKey={setSearchKey} />,
          //   ]}
          columns={columns}
          renderCell={renderCell}
          data={brands}
        />
      </Grid>
    </Grid>
  );
}

export function ToolBar({ setPage, setSearchKey }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div>
        <Search setPage={setPage} setSearchKey={setSearchKey} />
      </div>
    </div>
  );
}
